import React, {useState} from 'react';

import * as S from './SeoFiltersCard.styles';

const SeoFiltersCard = ({filterLinks = []}) => {
  const initialFilterlistLimit = 8;

  const initialAllFilter = () => {
    let temp = {};
    filterLinks.map(({title = ''}) => {
      temp[title] = initialFilterlistLimit;
    });
    return temp;
  };

  let allFilterShowList = initialAllFilter();

  const [FilterListLimit, setFilterListLimit] = useState(allFilterShowList);
  const [openedFilter, setOpenedFilter] = useState('');

  return (
    filterLinks.map(({link_data = [], title}) => (
      <S.GoSafeCardBlockWrapper>
        <S.SeoSrpContainerDiv>
          <S.SeoSrpHeaderPara>{title}</S.SeoSrpHeaderPara>
          <S.SeoSrpContentDiv>
            {link_data.slice(0, FilterListLimit[title]).map(item => (
              <li>
                <S.CityLink href={item.url}>{item.n}</S.CityLink>
                {/* hotel_number yet to be come from api . Have to change it accordingly*/}
                <S.CityNumberSpan>{item?.hotel_number || ''}</S.CityNumberSpan>
              </li>
            ))}
          </S.SeoSrpContentDiv>
          {link_data.length > initialFilterlistLimit &&
            ((FilterListLimit[title] < link_data.length && (
              <S.ShowAllLink
                onClick={() => {
                  allFilterShowList[title] = link_data.length;
                  if (openedFilter) allFilterShowList[openedFilter] = initialFilterlistLimit;
                  setOpenedFilter(title);
                  setFilterListLimit(allFilterShowList);
                }}
              >
                + Show All
              </S.ShowAllLink>
            )) || (
              <S.ShowAllLink
                onClick={() => {
                  setOpenedFilter('');
                  setFilterListLimit(initialAllFilter());
                }}
              >
                - Show Less
              </S.ShowAllLink>
            ))}
        </S.SeoSrpContainerDiv>
      </S.GoSafeCardBlockWrapper>
    )) || null
  );
};

export default SeoFiltersCard;
